import request from '@/utils/request'

export function selectMaterialInventory(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/materialInventory/selectMaterialInventory?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function addMaterialInventory(data) {
    return request({
        url: `api/serviceCenter/materialInventory/addMaterialInventory`,
        method: 'post',
        data,
    })
}

export function upDateMaterialInventory(data) {
    return request({
        url: `api/serviceCenter/materialInventory/upDateMaterialInventory`,
        method: 'post',
        data,
    })
}

export function bathDeleteMaterialInventory(data) {
    return request({
        url: `api/serviceCenter/materialInventory/bathDeleteMaterialInventory`,
        method: 'post',
        data,
    })
}







